import Cookies from 'js-cookie'

const TokenKey = 'chat-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

// 获取当前用户的医院ID
export function getHospitalId() {
  // 首先尝试从localStorage获取
  const hospitalId = localStorage.getItem('hospitalId')
  if (hospitalId) {
    return hospitalId
  }

  // 如果localStorage中没有，尝试从token中提取
  const token = getToken()
  if (token && token.startsWith('hospital_')) {
    const parts = token.split('_')
    if (parts.length >= 2 && parts[1] !== 'unknown') {
      return parts[1]
    }
  }

  // 默认返回null，表示未找到
  return null
}

// 获取当前用户的医院信息
export function getHospitalInfo() {
  const hospitalInfo = localStorage.getItem('hospitalInfo')
  return hospitalInfo ? JSON.parse(hospitalInfo) : null
}

// 获取当前用户的医院类型
export function getHospitalType() {
  return localStorage.getItem('hospitalType')
}


// 清除用户和医院信息
export function clearUserData() {
  localStorage.removeItem('hospitalId')
  localStorage.removeItem('hospitalInfo')
  localStorage.removeItem('hospitalType')
  localStorage.removeItem('userInfo')
  // 移除了communityInfo相关代码，因为统一使用hospitalInfo

  // 清除所有医院相关的缓存数据
  clearAllHospitalCache()
}

// 清除所有医院的缓存数据
export function clearAllHospitalCache() {
  const keysToRemove = []

  // 遍历所有localStorage键，找到以hospitalSettings_开头的键
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.startsWith('hospitalSettings_')) {
      keysToRemove.push(key)
    }
  }

  // 删除找到的所有医院设置缓存
  keysToRemove.forEach(key => {
    localStorage.removeItem(key)
  })

  // 也清除通用的hospitalSettings键
  localStorage.removeItem('hospitalSettings')
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}